
export const onlineOrOnLocation = {
  data () {
    return {
      onlineWaiver: process.env.VUE_APP_ONLINE_WAIVER
    }
  },
  computed: {
    isOnline () {
      return process.env.VUE_APP_ONLINE_WAIVER === '1'
    },
    isOnLocation () {
      return process.env.VUE_APP_ONLINE_WAIVER === '0'
    }
  }
}